import { ChangeDetectorRef, Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { LocalizationService } from '../../Services/localization-service';


@Component({
  selector: 'app-change-language-component',
  standalone: true,
  imports: [],
  templateUrl: './change-language-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './change-language-component.scss'
})
export class ChangeLanguageComponent implements OnInit {
  availableLangs = environment.supportedLangs;
  currentLang = environment.defaultLang;

  private readonly router = inject(Router);
  private readonly localizationService = inject(LocalizationService);
  private readonly cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.localizationService.getLanguage().subscribe(lang => {
      // Try to use the URL first to avoid mismatch
      const segments = this.router.url.split('/').filter(Boolean);
      const urlLang = segments.length ? segments[0] : null;
      this.currentLang = (urlLang && this.availableLangs.includes(urlLang)) ? urlLang : lang;
      this.cdr.detectChanges();
    });
  }

  onLangChange(newLang: string): void {
    if (!this.availableLangs.includes(newLang)) return;
    // Navigate to the same route but with replaced language segment
    const segments = this.router.url.split('/').filter(Boolean);
    if (segments.length) {
      segments[0] = newLang;
      const newUrl = '/' + segments.join('/');
      window.location.href= newUrl;
    } else {
      this.router.navigate(['/', newLang]);
    }
    this.cdr.detectChanges();
  }

  getLangLabel(lang: string): string {
    switch (lang) {
      case 'fa-IR': return 'Fa';
      case 'tr-TR': return 'Tr';
      case 'de-DE': return 'De';
      case 'en-US':
      default: return 'En';
    }
  }

  getFlag(lang: string): string {
    switch (lang) {
      case 'fa-IR': return '/assets/flags/ir.png';
      case 'en-US': return '/assets/flags/us.png';
      case 'tr-TR': return '/assets/flags/tr.png';
      case 'de-DE': return '/assets/flags/de.png';
      default: return '';
    }
  }
}
